module.exports = __webpack_public_path__ + "static/img/color-gun_256.6610eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color-gun_256.png
// module id = OEM4
// module chunks = 0